export default __webpack_public_path__ + "static/media/logo2.ff092407.png";